import { gql } from "@apollo/client";
import {
  CarouselStories,
  Feature,
  ListInductees,
  Hero,
  InlineRedirect,
  Title,
  CarouselShop,
  ListingEvents,
  GridInductees,
  Banner,
  SectionEnd,
  StickyNav,
  FloatSpotlight,
  QuickLinks,
  Milestones,
  TextImage,
  QuoteCarousel,
  Logos,
  FormEmbed,
  ComparisonTable,
  Accordion,
  List,
  Pricing,
  IconGrid,
  ImageSingular,
  ImageGallery,
  VideoPlaylist,
  VideoSingular,
  VideoCarousel,
  CarouselInductees,
  GoogleMap,
  WifiForm,
  FeatureEvents,
  ListingEventsFull,
  Intro,
  Ticketing,
  DonateForm,
  DetailHeroFlexibleContent,
  RichText,
  GenericEmbed,
  CarouselRockHallTv,
  FeatureExhibitsInteractives,
  ListingPressReleases,
  ArtifactSingular,
  HoursManual,
} from "@/components";

import Quiz from "@/components/DigitalExhibit/DigitalExhibitQuiz/DigitalExhibitQuiz";

export const FlexiblePageContentFragment = gql`
  ${Hero.fragments.entry}
  ${Feature.fragments.entry}
  ${CarouselStories.fragments.entry}
  ${ListInductees.fragments.entry}
  ${InlineRedirect.fragments.entry}
  ${Title.fragments.entry}
  ${CarouselShop.fragments.entry}
  ${ListingEvents.fragments.entry}
  ${GridInductees.fragments.entry}
  ${Banner.fragments.entry}
  ${StickyNav.fragments.entry}
  ${SectionEnd.fragments.entry}
  ${FloatSpotlight.fragments.entry}
  ${QuickLinks.fragments.entry}
  ${Milestones.fragments.entry}
  ${TextImage.fragments.entry}
  ${QuoteCarousel.fragments.entry}
  ${Logos.fragments.entry}
  ${FormEmbed.fragments.entry}
  ${ComparisonTable.fragments.entry}
  ${Accordion.fragments.entry}
  ${List.fragments.entry}
  ${Pricing.fragments.entry}
  ${IconGrid.fragments.entry}
  ${ImageSingular.fragments.entry}
  ${ImageGallery.fragments.entry}
  ${VideoPlaylist.fragments.entry}
  ${VideoSingular.fragments.entry}
  ${VideoCarousel.fragments.entry}
  ${CarouselInductees.fragments.entry}
  ${GoogleMap.fragments.entry}
  ${WifiForm.fragments.entry}
  ${FeatureEvents.fragments.entry}
  ${ListingEventsFull.fragments.entry}
  ${Intro.fragments.entry}
  ${Ticketing.fragments.entry}
  ${DonateForm.fragments.entry}
  ${DetailHeroFlexibleContent.fragments.entry}
  ${RichText.fragments.entry}
  ${GenericEmbed.fragments.entry}
  ${CarouselRockHallTv.fragments.entry}
  ${FeatureExhibitsInteractives.fragments.entry}
  ${ListingPressReleases.fragments.entry}
  ${ArtifactSingular.fragments.entry}
  ${HoursManual.fragments.entry}
  ${Quiz.fragments.entry}
  fragment ContentFragment on FlexiblePageContent {
    content {
      ...Hero
      ...Feature
      ...CarouselStories
      ...ListInductees
      ...Title
      ...InlineRedirect
      ...CarouselShop
      ...ListingEvents
      ...GridInductees
      ...Banner
      ...StickyNav
      ...SectionEnd
      ...FloatSpotlight
      ...QuickLinks
      ...Milestones
      ...TextImage
      ...QuoteCarousel
      ...Logos
      ...FormEmbed
      ...ComparisonTable
      ...Accordion
      ...List
      ...Pricing
      ...IconGrid
      ...ImageSingular
      ...ImageGallery
      ...VideoPlaylist
      ...VideoSingular
      ...VideoCarousel
      ...CarouselInductees
      ...GoogleMap
      ...WifiForm
      ...FeatureEvents
      ...ListingEventsFull
      ...Intro
      ...Ticketing
      ...DonateForm
      ...DetailHeroFlexibleContent
      ...RichText
      ...GenericEmbed
      ...CarouselRHTV
      ...FeatureExhibitsInteractives
      ...ListingPressReleases
      ...ArtifactSingular
      ...HoursManual
      ...FlexibleLayoutQuiz
    }
  }
`;